import React from 'react';

const DetailedLabel = (props) => {
    const {
        detailedLabel   = '',
        required        = false,
        style           = {}
    } = props;

    const renderLabel = () => {
        if (required) {
            return (
                <>
                    {detailedLabel} <span className={'text-danger'}>*</span>
                </>
            )
        }

        return detailedLabel;
    }

    if (!detailedLabel || detailedLabel === '') {
        return null;
    }

    return (
        <div className={"form-input-label"} style={style}>{renderLabel()}</div>
    );
}

export default DetailedLabel;
